// Shim for webpack ProvidePlugin: resolves $ and jQuery to the CDN-loaded global
module.exports = window.jQuery;
